export enum TfaformsParametersList {
  legId = 'tfa_1',
  sfdcAccountId = 'tfa_2196',
  tripDate = 'tfa_2242',
  fosTripNumber = 'tfa_2260',
}
